export default __webpack_public_path__ + "static/media/JAS0170.34I-43643_-26079_0.34f033c6.jpg";